import React, { useEffect, useState } from "react";
import "./EmailModal.css";

export default function EmailPresupuestoModal({
  isOpen,
  onClose,
  presupuesto,
  empresa,
  emailSettings,
  onSend,
}) {
  const [to, setTo] = useState("");
  const [cc, setCc] = useState("");
  const [bcc, setBcc] = useState("");
  const [subject, setSubject] = useState("");
  const [body, setBody] = useState("");

  useEffect(() => {
    if (!presupuesto || !emailSettings) return;

    const numero = presupuesto.numero || presupuesto.id;
    const empresaNombre = empresa?.nombre || "Narfran 2020 SL";

    /* =========================
       EMAIL DEL CLIENTE
    ========================= */
    setTo(
      presupuesto.cliente_email ||
        presupuesto.email ||
        presupuesto.cliente?.email ||
        ""
    );

    /* =========================
       ASUNTO
    ========================= */
    let tplSubject =
      emailSettings.asunto_presupuesto ||
      `Presupuesto {{NUMERO}} - ${empresaNombre}`;

    tplSubject = tplSubject
      .replace(/{{NUMERO}}/g, numero)
      .replace(/{{EMPRESA}}/g, empresaNombre);

    setSubject(tplSubject);

    /* =========================
       CUERPO + FIRMA (HTML REAL)
    ========================= */
    let tplBody =
      emailSettings.plantilla_presupuesto ||
      "Adjuntamos su presupuesto en PDF.";

    tplBody = tplBody
      .replace(/{{NUMERO}}/g, numero)
      .replace(/{{EMPRESA}}/g, empresaNombre);

    const firmaHtml = emailSettings.firma_html || "";



const firmaTextoPlano = firmaHtml
  ? firmaHtml
      .replace(/<br\s*\/?>/gi, "\n")
      .replace(/<\/p>/gi, "\n")
      .replace(/<[^>]*>/g, "")
  : "";

const finalBody =
  tplBody +
  "\n\n" +
  firmaTextoPlano;

setBody(finalBody);


    setBody(finalBody);
  }, [presupuesto, empresa, emailSettings]);

  if (!isOpen || !presupuesto) return null;

  /* =========================
     ENVÍO CONTROLADO
  ========================= */
  const handleSend = () => {
    if (!to || !to.trim()) {
      alert("El campo 'Para' es obligatorio");
      return;
    }

    const html = `
      <div>
        ${body.replace(/\n/g, "<br/>")}
      </div>
    `;

    onSend({
      to,
      cc,
      bcc,
      subject,
      html,
    });
  };

  return (
    <div className="email-modal-overlay">
      <div className="email-modal-container">
        <h2 className="email-title">Enviar Presupuesto por Email</h2>

        {/* PARA */}
        <label className="email-label">Para:</label>
        <input
          className="email-input"
          type="text"
          value={to}
          placeholder="correo1@example.com, correo2@example.com"
          onChange={(e) => setTo(e.target.value)}
        />

        {/* CC */}
        <label className="email-label">CC:</label>
        <input
          className="email-input"
          type="text"
          value={cc}
          placeholder="Opcional"
          onChange={(e) => setCc(e.target.value)}
        />

        {/* CCO */}
        <label className="email-label">CCO:</label>
        <input
          className="email-input"
          type="text"
          value={bcc}
          placeholder="Opcional"
          onChange={(e) => setBcc(e.target.value)}
        />

        {/* ASUNTO */}
        <label className="email-label">Asunto:</label>
        <input
          className="email-input"
          type="text"
          value={subject}
          onChange={(e) => setSubject(e.target.value)}
        />

        {/* MENSAJE */}
        <label className="email-label">Mensaje:</label>
        <textarea
          className="email-textarea"
          rows="7"
          value={body}
          onChange={(e) => setBody(e.target.value)}
        />

        {/* INFO ADJUNTO */}
        <div className="email-adjunto-box">
          <strong>Se adjuntará:</strong>{" "}
          {`Presupuesto ${presupuesto.numero || presupuesto.id} en PDF`}
        </div>

        {/* BOTONES */}
        <div className="email-buttons">
          <button className="email-btn-cancel" onClick={onClose}>
            Cancelar
          </button>

          <button
            className="email-btn-send"
            onClick={handleSend}
          >
            Enviar Email
          </button>
        </div>
      </div>
    </div>
  );
}
